export default __webpack_public_path__ + "static/video_nlploop-5054fc1d3c043ba3e0f434869eae68c3.mp4";